export default __webpack_public_path__ + "static/3-210bf88d8561b88ab5a7794c5e68ae0e.jpg";